// import logo from "./logo.svg";
import { useState, useEffect, useRef } from "react";
import "./App.css";
import "./App.scss";

import Search from "./Components/Search";
import Tags from "./Components/Tags";
import Main from "./Components/Main";
import NavigatePages from "./Components/NavigatePages";
import Spinner from "./Components/Spinner";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

function App() {
  const [selectedGenre, setSelectedGenre] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [searchCount, setSearchCount] = useState(0);

  const [isHiddenNavigationPage, setIsHiddenNavigationPage] = useState(true);
  const [isMainHidden, setIsMainHidden] = useState(false);

  return (
    <div className="App">
      <Search
        setSearchCount={setSearchCount}
        searchCount={searchCount}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <Tags selectedGenre={selectedGenre} setSelectedGenre={setSelectedGenre} />
      <Spinner
        visible={isMainHidden}
        text={"Loading Movies"}
        type={"TailSpin"}
      />
      <Main
        isMainHidden={isMainHidden}
        setIsMainHidden={setIsMainHidden}
        page={pageNumber}
        setPageNumber={setPageNumber}
        selectedGenre={selectedGenre}
        searchTerm={searchTerm}
        setIsHiddenNavigationPage={setIsHiddenNavigationPage}
        searchCount={searchCount}
        isSimilar={false}
        selectedMovieID={""}
      />
      <NavigatePages
        isHiddenNavigationPage={isHiddenNavigationPage}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />
    </div>
  );
}

export default App;
